import { useMemo, useState } from 'react';
import HumanResourceLayout from "../../../components/layouts/HumanResourceLayout";
import { Helmet } from "react-helmet-async";
import CustomTab from "../../../components/custom_tab/CustomTab";
import { useSearchParams } from 'react-router-dom';
import DisciplinaryActionsView from './views/DisciplinaryActionsView';
import GrievanceReportsView from './views/GrievanceReportsView';
import PayrollCompanyLayout from '../../../components/layouts/PayrollCompanyLayout';
import useUserStore from '../../../state-management/useUserStore';

const DisciplinaryAndGrievance = () => {
	const { userType } = useUserStore();
	const LAYOUT = useMemo(() => {
		switch(userType) {
			case "ORGANIZATION": 
				return PayrollCompanyLayout;
			default: 
				return HumanResourceLayout;
		}
	}, [userType])
	const [searchParams] = useSearchParams();
	const [view, setView] = useState(
		searchParams.get("view") || "disciplinary"
	);

	return (
		<LAYOUT>
			<Helmet>
				<title>Disciplinary & Grievance |{userType === "HR" ? " HR " : " Company "}Flow</title>
			</Helmet>
			<h1 className="font-bold text-xl mb-8">Disciplinary & Grievance</h1>
			<CustomTab
				view={view}
				setView={setView}
				tabColumns={DisciplinaryAndGrievanceTabColumns}
			>
				<div className="mt-6">
					{view === "disciplinary" && <DisciplinaryActionsView />}
					{view === "grievance" && <GrievanceReportsView />}
				</div>
			</CustomTab>
		</LAYOUT>
	);
};

export default DisciplinaryAndGrievance;

const DisciplinaryAndGrievanceTabColumns = [
	{
		view: "disciplinary",
		name: "Disciplinary",
	},
	{
		view: "grievance",
		name: "Grievance",
	},
];